// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__cNIE4","App-logo":"App_App-logo__1OqFB","App-logo-spin":"App_App-logo-spin__2OFbu","App-header":"App_App-header__3ezDY","App-link":"App_App-link__3W9QP"};